import { createFetchReducer } from '../helpers/fetchData'
import actions from './actions'

const giftCardDesign = createFetchReducer({ name: actions.giftCardDesignApiName })

export default giftCardDesign
